module.exports = __webpack_public_path__ + "img/i-swipe-12.5cd29d2c.png";